
import { defineComponent } from "vue";
import { FieldArray } from "vee-validate";
import TextField from "../textField/index.vue";
import RenderCheckBox from "../renderCheckbox/index.vue";
import CustomDatePicker from "../datePicker/index.vue";
import { hexToRGBA } from "@/utils/functions";

const EducationArrayField = defineComponent({
  name: "EducationArrayField",
  props: {
    primaryColor: {
      type: String,
      default: "#7E24ED",
    },
  },
  components: {
    FieldArray,
    TextField,
    RenderCheckBox,
    CustomDatePicker,
  },
  setup() {
    return {
      hexToRGBA,
    };
  },
});

export default EducationArrayField;
